import { View } from 'react-native';
import { useSelector } from 'react-redux';
import { Divider } from '@ui-kitten/components';

import { textCategory } from '../../../Components/Reservation/constants';
import { ids, styles } from '../../../Components/Reservation/styles';
import ResponsiveText from '../../../Components/ResponsiveText';
import { selectReservationCheckoutData } from '../../../RTK/utility/selectors';
import themeStyle from '../../../Theme/styles';

import { ReservationCheckout as ReservationCheckoutType } from '../types';

import Summary from './Summary';

const EventLeftColumnContent = () => {
  const checkoutData: ReservationCheckoutType = useSelector(
    selectReservationCheckoutData,
  );

  return (
    <View dataSet={{ media: ids.detailsBox }} style={styles.detailsBox}>
      <ResponsiveText category={textCategory.TITLE}>
        Order Summary
      </ResponsiveText>
      <View style={themeStyle.pageVerticalSpacingMedium}>
        <ResponsiveText category={textCategory.HEADING} style={themeStyle.bold}>
          {checkoutData.storeName}
        </ResponsiveText>
        <ResponsiveText category={textCategory.BODY}>
          {checkoutData.itemName}
        </ResponsiveText>
      </View>
      <Divider style={themeStyle.divider} />
      <Summary
        data={checkoutData}
        isReservation={checkoutData.isReservation}
        withAddress
        withCostBreakdown
        withPrice
      />
    </View>
  );
};

export default EventLeftColumnContent;
